/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Your_DetailsInputs */

const en_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your details`)
};

const es_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus datos`)
};

const de_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Daten`)
};

const zh_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的详细信息`)
};

const ar_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بياناتك`)
};

const fr_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos coordonnées`)
};

const vi_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin của bạn`)
};

const sw_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maelezo yako`)
};

const th_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายละเอียดของคุณ`)
};

const bs_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaši podaci`)
};

const ja_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お客様情報`)
};

const ko_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예약자 정보`)
};

const pt_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seus dados`)
};

const it_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi dati`)
};

const sv_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dina uppgifter`)
};

const nl_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je gegevens`)
};

const da_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dine oplysninger`)
};

const nb_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dine opplysninger`)
};

const fi_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietosi`)
};

const pl_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje dane`)
};

const ru_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваши данные`)
};

const tr_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilgileriniz`)
};

const hi_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपका विवरण`)
};

const id_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rincian Anda`)
};

const ms_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butiran anda`)
};

const cs_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaše údaje`)
};

const el_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τα στοιχεία σας`)
};

const he_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הפרטים שלכם`)
};

const af_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jou besonderhede`)
};

const hu_booking_your_details = /** @type {(inputs: Booking_Your_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adataid`)
};

/**
* | output |
* | --- |
* | "Your details" |
*
* @param {Booking_Your_DetailsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_your_details = /** @type {((inputs?: Booking_Your_DetailsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Your_DetailsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_your_details(inputs)
	if (locale === "de") return de_booking_your_details(inputs)
	if (locale === "zh") return zh_booking_your_details(inputs)
	if (locale === "ar") return ar_booking_your_details(inputs)
	if (locale === "fr") return fr_booking_your_details(inputs)
	if (locale === "vi") return vi_booking_your_details(inputs)
	if (locale === "sw") return sw_booking_your_details(inputs)
	if (locale === "th") return th_booking_your_details(inputs)
	if (locale === "bs") return bs_booking_your_details(inputs)
	if (locale === "ja") return ja_booking_your_details(inputs)
	if (locale === "ko") return ko_booking_your_details(inputs)
	if (locale === "pt") return pt_booking_your_details(inputs)
	if (locale === "it") return it_booking_your_details(inputs)
	if (locale === "sv") return sv_booking_your_details(inputs)
	if (locale === "nl") return nl_booking_your_details(inputs)
	if (locale === "da") return da_booking_your_details(inputs)
	if (locale === "nb") return nb_booking_your_details(inputs)
	if (locale === "fi") return fi_booking_your_details(inputs)
	if (locale === "pl") return pl_booking_your_details(inputs)
	if (locale === "ru") return ru_booking_your_details(inputs)
	if (locale === "tr") return tr_booking_your_details(inputs)
	if (locale === "hi") return hi_booking_your_details(inputs)
	if (locale === "id") return id_booking_your_details(inputs)
	if (locale === "ms") return ms_booking_your_details(inputs)
	if (locale === "cs") return cs_booking_your_details(inputs)
	if (locale === "el") return el_booking_your_details(inputs)
	if (locale === "he") return he_booking_your_details(inputs)
	if (locale === "af") return af_booking_your_details(inputs)
	if (locale === "hu") return hu_booking_your_details(inputs)
	return en_booking_your_details(inputs)
});